// ***************************************
// tgfComponents.ScrollBox
//
// This is a scrollbox in which you can scroll
// and clip other components
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 5-7-2015
// ***************************************
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { tbContainer } from "../../engine/tbContainer";
import { tbEase } from "../../engine/tbEase";
import { tbGraphics } from "../../engine/tbGraphics";
import { tbVector } from "../../engine/tbVector";
import { tgfSettings } from "../tgfSettings";
import { ComponentBase } from "./ComponentBase";
import { ScrollBarDirection, ComponentScrollBar } from "./ComponentScrollBar";
tgfSettings.componentDefaults.scrollBox = {
    scrollHorizontal: true,
    scrollVertical: true,
    areaWidth: 0,
    areaHeight: 0,
    clip: true,
    showHorizontalScrollBar: false,
    showVerticalScrollBar: false,
    cancelEvents: true,
    scrollBarProperties: null,
    horizontalScrollBarProperties: null,
    verticalScrollBarProperties: null,
    scrollBackDuration: 600,
    snapIntervals: 0,
    maxSpeedForSnap: 500,
    snapCallback: null,
    components: [] // Components to add as children in the box
};
var ComponentScrollBox = /** @class */ (function (_super) {
    __extends(ComponentScrollBox, _super);
    function ComponentScrollBox(properties) {
        var _this = _super.call(this) || this;
        _this.name = "ScrollBox";
        // Initialize properties
        _this.initialize(tgfSettings.componentDefaults.scrollBox);
        // Set user properties
        if (properties !== undefined) {
            _this.setProperties(properties);
        }
        _this.scrollBackTimer = new tbVector(0, 0);
        _this.scrollBackFrom = new tbVector(0, 0);
        _this.scrollBackTo = new tbVector(0, 0);
        _this.scroll = new tbVector(0, 0);
        _this.touchStartScroll = new tbVector(0, 0);
        _this.centerOffset = new tbVector(0, 0);
        return _this;
    }
    /**
     * Remove all the elements in the scrollBox
     */
    ComponentScrollBox.prototype.clearElements = function () {
        this.scrollContainer.removeAllComponents();
    };
    ComponentScrollBox.prototype.getScroll = function () {
        return this.scroll;
    };
    // setWidthHeight - change the width and height of the scrollbox to adapt to a new screen resolution
    ComponentScrollBox.prototype.setWidthHeight = function (width, height) {
        if (this.width === width && this.height === height) {
            return;
        }
        this.width = width;
        this.height = height;
        // this.surface = new tbSurface(this.width - (this.verticalScrollBar?this.verticalScrollBar.getWidth():0), this.height - (this.horizontalScrollBar?this.horizontalScrollBar.getHeight():0));
        // this.surface.context.translate(Math.round(this.width / 2), Math.round(this.height / 2));
    };
    // ***************************************
    // Preparing, showing and activating
    //		- These can be removed if no processing is required
    // ***************************************
    // Processing required when preparing the component for use
    ComponentScrollBox.prototype.doPrepare = function () {
        var i, ww = Math.round(this.width / 2), hh = Math.round(this.height / 2);
        this.scroll.x = 0;
        this.scroll.y = 0;
        this.touchStart = new tbVector(0, 0);
        this.touchEnd = new tbVector(0, 0);
        this.speed = new tbVector(0, 0);
        if (this.showVerticalScrollBar && this.scrollVertical) {
            this.verticalScrollBar = new ComponentScrollBar();
            this.verticalScrollBar.setProperties(this.scrollBarProperties);
            this.verticalScrollBar.setProperties(this.verticalScrollBarProperties);
            this.verticalScrollBar.x = (this.width - this.verticalScrollBar.getWidth()) / 2;
            this.verticalScrollBar.y = 0;
            this.verticalScrollBar.height = this.height;
            this.addComponent(this.verticalScrollBar);
            ww -= this.verticalScrollBar.getWidth() / 2;
        }
        if (this.showHorizontalScrollBar && this.scrollHorizontal) {
            this.horizontalScrollBar = new ComponentScrollBar({ direction: ScrollBarDirection.Horizontal });
            this.horizontalScrollBar.setProperties(this.scrollBarProperties);
            this.horizontalScrollBar.setProperties(this.horizontalScrollBarProperties);
            this.horizontalScrollBar.x = 0;
            this.horizontalScrollBar.y = (this.height - this.horizontalScrollBar.getHeight()) / 2;
            this.horizontalScrollBar.width = this.width;
            this.addComponent(this.horizontalScrollBar);
            hh -= this.horizontalScrollBar.getHeight() / 2;
        }
        if (this.verticalScrollBar && this.horizontalScrollBar) {
            this.verticalScrollBar.height -= this.horizontalScrollBar.getHeight();
            this.verticalScrollBar.y -= this.horizontalScrollBar.getHeight() / 2;
            this.horizontalScrollBar.width -= this.verticalScrollBar.getWidth();
            this.horizontalScrollBar.x -= this.verticalScrollBar.getWidth() / 2;
        }
        this.finger = -1;
        this.scrollContainer = new tbContainer(this.areaWidth, this.areaHeight);
        this.scrollContainer.x = this.scroll.x;
        this.scrollContainer.y = this.scroll.y;
        this.surface = tbGraphics.drawRectangle(this.containerRelativeX() - this.width / 2, this.containerRelativeY() - this.height / 2, this.width - (this.verticalScrollBar ? this.verticalScrollBar.getWidth() : 0), this.height - (this.horizontalScrollBar ? this.horizontalScrollBar.getHeight() : 0), 0x0000ff, null, 0, .15);
        // add containers
        this.baseContainer.addChild(this.scrollContainer);
        if (this.clip) {
            this.baseContainer.addChild(this.surface);
            this.scrollContainer.container.mask = this.surface;
        }
        this.centerOffset.x = -Math.round(this.width - this.surface.width) / 2;
        this.centerOffset.y = -Math.round(this.height - this.surface.height) / 2;
        // Add the child components
        if (this.components) {
            for (i = 0; i < this.components.length; i += 1) {
                this.components[i].baseContainer = this.scrollContainer;
                this.addComponent(this.components[i]);
            }
        }
        if (this.startPosition) {
            if (this.scrollVertical) {
                var areaHeight = Math.max(this.areaHeight, this.surface.height);
                var minY = -(areaHeight - this.surface.height);
                this.scroll.y = this.startPosition * minY;
            }
            else if (this.scrollHorizontal) {
                var areaWidth = Math.max(this.areaWidth, this.surface.width);
                var minX = -(areaWidth - this.surface.width);
                this.scroll.x = this.startPosition * minX;
            }
        }
    };
    // Processing required when freeing the component from use
    ComponentScrollBox.prototype.doFree = function () {
        if (this.surface) {
            this.baseContainer.removeChild(this.surface);
        }
        if (this.scrollContainer) {
            this.scrollContainer.remove(this.baseContainer);
            this.scrollContainer.free();
            this.scrollContainer = null;
        }
    };
    // Processing required when showing the component
    ComponentScrollBox.prototype.doShow = function () {
    };
    // Processing required when hiding the component
    ComponentScrollBox.prototype.doHide = function () {
    };
    // Processing required when activating the component
    ComponentScrollBox.prototype.doActivate = function () {
    };
    // Processing required when deactivating the component
    ComponentScrollBox.prototype.doDeactivate = function () {
    };
    // Methods for forcing what the min and max scrolling coordinates should be.
    ComponentScrollBox.prototype.getMinX = function () {
        if (this.forcedMinX) {
            return this.forcedMinX;
        }
        var areaWidth = Math.max(this.areaWidth, this.width);
        return -(areaWidth - this.width);
    };
    ComponentScrollBox.prototype.getMaxX = function () {
        if (this.forcedMaxX) {
            return this.forcedMaxX;
        }
        return 0;
    };
    ComponentScrollBox.prototype.getMinY = function () {
        if (this.forcedMinY) {
            return this.forcedMinY;
        }
        var areaHeight = Math.max(this.areaHeight, this.height);
        return -(areaHeight - this.height);
    };
    ComponentScrollBox.prototype.getMaxY = function () {
        if (this.forcedMaxY) {
            return this.forcedMaxY;
        }
        return 0;
    };
    // ***************************************
    // Methods called when events must be processed
    //		- These can be removed when no processing is required
    //		- When they return true, this event is no further processed
    //			by other components in the dialog
    //		- Never call these methods yourself in other components,
    //			Use the inherited handle methods instead
    // ***************************************
    // Called at the beginning of each step
    ComponentScrollBox.prototype.doBeginStep = function (timePassed) {
    };
    // Called when a touch is started or if a mouse button is pressed
    ComponentScrollBox.prototype.doTouchDown = function (finger, x, y) {
        // Check whether the touch is within the scrollbox
        if (x >= -this.width / 2 && x <= this.width / 2 && y >= -this.height / 2 && y <= this.height / 2) {
            this.finger = finger;
            x = this.touchX(this.finger);
            y = this.touchY(this.finger);
            this.scrollBackTimer.x = 0;
            this.scrollBackTimer.y = 0;
            this.touchStart.x = x;
            this.touchStart.y = y;
            this.touchStartScroll.x = this.scroll.x;
            this.touchStartScroll.y = this.scroll.y;
            if (this.cancelEvents) {
                return true;
            }
        }
    };
    // Called when a touch is started or if a mouse button is pressed
    ComponentScrollBox.prototype.doMouseWheel = function (delta, x, y) {
        var ww = Math.round(this.width), hh = Math.round(this.height);
        // Check whether the touch the scrollbox
        if (x >= -ww / 2 && x <= ww / 2 && y >= -hh / 2 && y <= hh / 2) {
            if (this.scrollVertical) {
                this.scroll.y += delta * 100;
                var maxY = this.getMaxY();
                var minY = this.getMinY();
                if (this.scroll.y > maxY) {
                    this.scroll.y = 0;
                }
                if (this.scroll.y < minY) {
                    this.scroll.y = minY;
                }
            }
            else if (this.scrollHorizontal) {
                this.scroll.x += delta * 100;
                var maxX = this.getMaxX();
                var minX = this.getMinX();
                if (this.scroll.x > maxX) {
                    this.scroll.x = 0;
                }
                if (this.scroll.x < minX) {
                    this.scroll.x = minX;
                }
            }
        }
    };
    // Called when a touch is ended or if a mouse button is released
    ComponentScrollBox.prototype.doTouchUp = function (finger, x, y) {
        if (this.finger !== finger) {
            return;
        }
        this.finger = -1;
        this._checkScrollOvershootX();
        this._checkScrollOvershootY();
    };
    ComponentScrollBox.prototype.cancelTouches = function () {
        this.finger = -1;
        this._checkScrollOvershootX();
        this._checkScrollOvershootY();
    };
    ComponentScrollBox.prototype._checkScrollOvershootX = function () {
        var maxX = this.getMaxX();
        var minX = this.getMinX();
        if (this.scroll.x > maxX) {
            this.scrollBackTimer.x = this.scrollBackDuration;
            this.scrollBackFrom.x = this.scroll.x;
            this.scrollBackTo.x = maxX;
            if (this.snapCallback) {
                this.snapCallback(Math.round(maxX / this.snapIntervals));
            }
        }
        if (this.scroll.x < minX) {
            this.scrollBackTimer.x = this.scrollBackDuration;
            this.scrollBackFrom.x = this.scroll.x;
            this.scrollBackTo.x = minX;
            if (this.snapCallback) {
                this.snapCallback(Math.round(minX / this.snapIntervals));
            }
        }
    };
    ComponentScrollBox.prototype._checkScrollOvershootY = function () {
        var maxY = this.getMaxY();
        var minY = this.getMinY();
        if (this.scroll.y > maxY) {
            this.scrollBackTimer.y = this.scrollBackDuration;
            this.scrollBackFrom.y = this.scroll.y;
            this.scrollBackTo.y = maxY;
            if (this.snapCallback) {
                this.snapCallback(Math.round(maxY / this.snapIntervals));
            }
        }
        if (this.scroll.y < minY) {
            this.scrollBackTimer.y = this.scrollBackDuration;
            this.scrollBackFrom.y = this.scroll.y;
            this.scrollBackTo.y = minY;
            if (this.snapCallback) {
                this.snapCallback(Math.round(minY / this.snapIntervals));
            }
        }
    };
    ComponentScrollBox.prototype._checkSnapIntervalX = function () {
        if (this.snapIntervals && this.scroll.x < this.getMaxX() && this.scroll.x > this.getMinX()) {
            var nearestSnap = this._findNearestSnap(this.scroll.x);
            if (nearestSnap !== this.scroll.x) {
                this.scrollBackTimer.x = this.scrollBackDuration;
                this.scrollBackFrom.x = this.scroll.x;
                this.scrollBackTo.x = nearestSnap;
                if (this.snapCallback) {
                    this.snapCallback(Math.round(this.scrollBackTo.x / this.snapIntervals));
                }
            }
        }
    };
    ComponentScrollBox.prototype._checkSnapIntervalY = function () {
        if (this.snapIntervals && this.scroll.y < this.getMaxY() && this.scroll.y > this.getMinY()) {
            var nearestSnap = this._findNearestSnap(this.scroll.y);
            if (nearestSnap !== this.scroll.y) {
                this.scrollBackTimer.y = this.scrollBackDuration;
                this.scrollBackFrom.y = this.scroll.y;
                this.scrollBackTo.y = nearestSnap;
                if (this.snapCallback) {
                    this.snapCallback(Math.round(this.scrollBackTo.y / this.snapIntervals));
                }
            }
        }
    };
    ComponentScrollBox.prototype._findNearestSnap = function (position) {
        var positionIntervalOffset = Math.abs(position % this.snapIntervals);
        if (positionIntervalOffset > this.snapIntervals / 2) {
            return Math.floor(position / this.snapIntervals) * this.snapIntervals;
        }
        else {
            return Math.ceil(position / this.snapIntervals) * this.snapIntervals;
        }
    };
    // Called at the end of each step
    ComponentScrollBox.prototype.doEndStep = function (timePassed) {
        var x, y;
        var minY, minX, maxX, maxY, normalizedScrollValue;
        var areaHeight = Math.max(this.areaHeight, this.surface.height);
        var areaWidth = Math.max(this.areaWidth, this.surface.width);
        minX = this.getMinX();
        minY = this.getMinY();
        maxX = this.getMaxX();
        maxY = this.getMaxY();
        if (this.finger !== -1) {
            if (this.scrollHorizontal) {
                x = this.touchX(this.finger);
                this.touchEnd.x = x;
                var scrollXValue = this.touchStartScroll.x + this.touchEnd.x - this.touchStart.x;
                this.speed.x = (this.speed.x + (scrollXValue - this.scroll.x) / (timePassed / 1000)) / 2;
                this.scroll.x = scrollXValue;
                if (this.scroll.x > maxX) {
                    this.scroll.x = maxX + Math.min(this.surface.width / 2, tbEase.easeOutCubic(scrollXValue - maxX, 0, this.surface.width / 2, this.surface.width)) / 2;
                }
                if (this.scroll.x < minX) {
                    normalizedScrollValue = scrollXValue - minX;
                    this.scroll.x = minX + Math.max(-this.surface.width / 2, tbEase.easeOutCubic(normalizedScrollValue, 0, -this.surface.width / 2, -this.surface.width)) / 2;
                }
            }
            if (this.scrollVertical) {
                y = this.touchY(this.finger);
                this.touchEnd.y = y;
                var scrollYValue = this.touchStartScroll.y + this.touchEnd.y - this.touchStart.y;
                this.speed.y = (this.speed.y + (scrollYValue - this.scroll.y) / (timePassed / 1000)) / 2;
                this.scroll.y = scrollYValue;
                if (this.scroll.y > maxY) {
                    this.scroll.y = maxY + Math.min(this.surface.height / 2, tbEase.easeOutCubic(scrollYValue - maxY, 0, this.surface.height / 2, this.surface.height)) / 2;
                }
                if (this.scroll.y < minY) {
                    normalizedScrollValue = scrollYValue - minY;
                    this.scroll.y = minY + Math.max(-this.surface.height / 2, tbEase.easeOutCubic(normalizedScrollValue, 0, -this.surface.height / 2, -this.surface.height)) / 2;
                }
            }
        }
        else {
            if (this.scrollBackTimer.x > 0) {
                this.scrollBackTimer.x -= timePassed;
                this.scrollBackTimer.x = Math.max(0, this.scrollBackTimer.x);
                this.scroll.x = tbEase.easeOutOvershoot(this.scrollBackDuration - this.scrollBackTimer.x, this.scrollBackFrom.x, this.scrollBackTo.x
                    - this.scrollBackFrom.x, this.scrollBackDuration);
                this.speed.x = 0;
            }
            else {
                if (Math.abs(this.speed.x) > 0) {
                    this.speed.x = this.speed.x * Math.pow(0.99, timePassed);
                    if (Math.abs(this.speed.x) > 1) {
                        this.scroll.x += this.speed.x * (timePassed / 1000);
                        if (this.scroll.x > 0 || this.scroll.x < minX) {
                            this.speed.x = 0;
                            this._checkScrollOvershootX();
                        }
                    }
                    else {
                        this.speed.x = 0;
                    }
                }
                if (Math.abs(this.speed.x) < this.maxSpeedForSnap && this.snapIntervals) {
                    this.speed.x = 0;
                    this._checkSnapIntervalX();
                }
            }
            if (this.scrollBackTimer.y > 0) {
                this.scrollBackTimer.y -= timePassed;
                this.scrollBackTimer.y = Math.max(0, this.scrollBackTimer.y);
                this.scroll.y = tbEase.easeOutOvershoot(this.scrollBackDuration - this.scrollBackTimer.y, this.scrollBackFrom.y, this.scrollBackTo.y
                    - this.scrollBackFrom.y, this.scrollBackDuration);
                this.speed.y = 0;
            }
            else {
                if (Math.abs(this.speed.y) > 0) {
                    this.speed.y = this.speed.y * Math.pow(0.99, timePassed);
                    if (Math.abs(this.speed.y) > 1) {
                        this.scroll.y += this.speed.y * (timePassed / 1000);
                        if (this.scroll.y > 0 || this.scroll.y < minY) {
                            this.speed.y = 0;
                            this._checkScrollOvershootY();
                        }
                    }
                    else {
                        this.speed.y = 0;
                    }
                }
                if (Math.abs(this.speed.y) < this.maxSpeedForSnap && this.snapIntervals) {
                    this.speed.y = 0;
                    this._checkSnapIntervalY();
                }
            }
        }
        if (this.verticalScrollBar) {
            this.verticalScrollBar.scrollRange = areaHeight - this.surface.height;
            this.verticalScrollBar.scrollPosition = Math.min(-minY, Math.max(0, -this.scroll.y));
            if (this.verticalScrollBar.touchScrollPosition !== undefined) {
                this.scroll.y = -this.verticalScrollBar.touchScrollPosition;
            }
        }
        if (this.horizontalScrollBar) {
            this.horizontalScrollBar.scrollRange = areaWidth - this.surface.width;
            this.horizontalScrollBar.scrollPosition = Math.min(-minX, Math.max(0, -this.scroll.x));
            if (this.horizontalScrollBar.touchScrollPosition !== undefined) {
                this.scroll.x = -this.horizontalScrollBar.touchScrollPosition;
            }
        }
        var sx = this.scroll.x; // + this.centerOffset.x;
        var sy = this.scroll.y; // + this.centerOffset.y;
        this.scrollContainer.setPosition(sx, sy);
    };
    ComponentScrollBox.prototype.goToSnapPointX = function (snapPoint) {
        this.scrollBackTimer.x = this.scrollBackDuration;
        this.scrollBackFrom.x = this.scroll.x;
        this.scrollBackTo.x = snapPoint * this.snapIntervals;
        if (this.snapCallback) {
            this.snapCallback(Math.round(this.scrollBackTo.x / this.snapIntervals));
        }
    };
    // Called just before drawing (also when not active)
    ComponentScrollBox.prototype.doUpdateVisuals = function (timePassed) {
    };
    // Called when the component must be drawn (relative to position 0, 0)
    ComponentScrollBox.prototype.doDraw = function () {
    };
    return ComponentScrollBox;
}(ComponentBase));
export { ComponentScrollBox };
